import React from "react";
import Header from "../components/generalComponents/Header";
import BottomNavBar from "../components/generalComponents/BottomNavBar";
import Profile from "../components/profile/Profile";

export default function ProfileView() {
  return (
    <div className="pageWrapper">
      <Header title="Profiel" />
      <div className="contentWrapper fadeInDelayed">
        <Profile />
      </div>
      <BottomNavBar />
    </div>
  );
}
